import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

const routes = [
  {
    path: 'documents',
    name: 'admin-documents',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.documents],
      module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-documents" */ '@tools/pages/document/document.vue'),
  },
];

export default routes;
